export enum PasswordFieldView {
  default,
  passwordInputField,
  codeInputField,
}
